/*
 * fuzzaldrin-react.tsx
 *
 * Created by Dr. Maximillian Dornseif 2021-12-06 in huWaWi3 24.7.2
 * Copyright (c) 2021 HUDORA GmbH
 */

import { filter } from 'fuzzaldrin-plus'
import React from 'react'

// sort with fuzzaldrin
export function fuzzaldrinSort(term: string, suggestions: any[]): any[] {
  return filter(suggestions, term, {
    key: 'title',
    allowErrors: true,
    usePathScoring: false,
  })
}

// Schicker wäre es, fuzzaldrin-plus.match zu nehmen.
// https://github.com/jeancroy/fuzz-aldrin-plus/issues/24#issuecomment-242246378
// wrap müsste eigentlich nur auf react umgeschrieben werden.
// https://github.com/jeancroy/fuzz-aldrin-plus/blob/master/src/matcher.coffee#L42
// der unten stehende Code ist aus Blueprint und highlightet nicht unbedingt das richtige
// check also 'autosuggest-highlight/parse';

export function fuzzaldrinHighlight(text: string, term: string) {
  let lastIndex = 0
  const words = term
    .split(/\s+/)
    .filter((word) => word.length > 0)
    .map(escapeRegExpChars)
  if (words.length === 0) {
    return [text]
  }
  const regexp = new RegExp(words.join('|'), 'gi')
  const tokens: React.ReactNode[] = []
  for (;;) {
    const match = regexp.exec(text)
    if (!match) {
      break
    }
    const length = match[0].length
    const before = text.slice(lastIndex, regexp.lastIndex - length)
    if (before.length > 0) {
      tokens.push(before)
    }
    lastIndex = regexp.lastIndex
    tokens.push(<strong key={lastIndex}>{match[0]}</strong>)
  }
  const rest = text.slice(lastIndex)
  if (rest.length > 0) {
    tokens.push(rest)
  }
  return <>{tokens}</>
}
function escapeRegExpChars(text) {
  return text.replace(/([!$()*+./:=?[\\\]^{|}])/g, '\\$1')
}
